// import axios from 'axios';

// const rocket = axios.create({
//     baseURL: '/dev-api',
//     headers: {
//         'Content-Type': 'application/json',
//     }
// })

// export default rocket;

import axios from 'axios';

const rocket = axios.create({
    // baseURL: 'https://dev2.ywmobile.co.kr:8207',
    // baseURL: 'http://external.star-t.dev:8207',
    timeout: 3000,
});

// rocket.interceptors.request.use((config) => {
//     console.log(config);
//     // if (config.url.includes("/dev-api")) {
//     //     config.url = "http://dev2.ywmobile.co.kr:8207";
//     // }
//     if (config.baseURL.includes("/dev-api")) {
//         config.baseURL = "http://dev2.ywmobile.co.kr:8207";
//     }
//     return config;
// });

rocket.interceptors.response.use(
    response => {
        const res = response.data
        if(res.result !== 0) {
            if(res.result === 9999) {
                alert(res.message + " | errCode : " + res.result);
                window.location.replace('/');
                return Promise.reject(response);
            } else {
                return Promise.reject(response);
            }
        } else {
            return response;
        }
    },
    error => {
        alert("서버 연결 에러 (" + error.response.status + ")");
        window.location.replace('/');
        return Promise.reject(error);
    }
)



export default rocket;